<template>
  <div ref="customSelectRef" class="custom-select-cities" :class="{'--open': isOpen}">
    <div
      class="custom-select-cities__select input"
      :class="(classSelect || '')"
      @click="openSelect"
    >
      <span>{{ modelValue }}</span>
      <img
        src="~/assets/img/svg/common/arrow-down.svg"
        alt="стрелка фильтра вниз"
      />
    </div>
    <template v-if="isOpen">
      <div class="custom-select-cities__dropdown">
        <div class="--search-content">
          <input v-model="search" type="text" class="--search" placeholder="Поиск"/>
        </div>
        <template v-if="search.length <= 2">
          <div class="--section">
            <div v-if="false" class="--title">Популярные города</div>
            <ul class="--items">
              <li v-for="(item) in favorites" class="cscd-option-item" @click="() => changeValue(item)">
                <span class="--value">
                  {{ item.name }}
                </span>
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <div class="--section">
            <ul class="--items">
              <li v-for="(item) in searchItems" class="cscd-option-item" @click="() => changeValue(item)">
                <span class="--value">{{ item.name }}</span>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { appConfigStore } from '#sitis/stores/modules/app-store';

const props = defineProps<{
  modelValue: any,
  classSelect?: string
}>();
const emits = defineEmits(["update:modelValue"]);
const {
  $api
} = useNuxtApp();
const appConfig = appConfigStore();
const currentCity = computed(() => appConfig?.config?.city?.model?.name || '');

const isOpen: Ref<boolean> = ref(false);
const openSelect = async () => {
  if (!isOpen.value) {
    isOpen.value = true;
    await getOptions();
  } else {
    isOpen.value = false;
  }
};

const search: Ref<string> = ref('');
const searchItems: ComputedRef<any[]> = computed(() => {
  const _search = String(search.value || '').toLowerCase();
  return [...(options.value || [])].filter((t: any) => String(t?.name || '').toLowerCase().includes(_search))
});

const options: Ref<any[]> = ref([]);
const favorites: Ref<any[]> = ref([]);
const isLoading: Ref<boolean> = ref(false);
const getOptions = async () => {
  if (isLoading.value || options.value.length > 0) {
    return
  }

  isLoading.value = true;
  const res = await $api.agent.get('/cities').then((res) => res._data).catch(() => []);

  isLoading.value = false;
  options.value = res?.cities || [];
  favorites.value = res?.favorites || [];
};

const changeValue = (option: any) => {
  emits('update:modelValue', option.name);
  isOpen.value = false;
};

const customSelectRef: Ref<any> = ref(null);
const handleClick = (event: any) => {
  if (customSelectRef.value && !customSelectRef.value.contains(event.target)) {
    isOpen.value = false;
  }
};
onMounted(() => {
  document.addEventListener('click', handleClick);
  if (!props.modelValue) {
    emits('update:modelValue', currentCity.value);
  }
});
onUnmounted(() => {
  document.removeEventListener('click', handleClick);
});
</script>

<style lang="scss">
.custom-select-cities {
  position: relative;
  &.--open {
    .input.custom-select-cities__select {
      background-color: white;
      border-bottom-left-radius: 0!important;
      border-bottom-right-radius: 0!important;
    }

    & > .custom-select-cities__select  > img {
      transform: rotate(180deg);
    }
  }
}
.custom-select-cities__select {
  width: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;
  & > img {
    transition: transform 0.1s ease-in-out;
  }
  span {
    flex: auto;
  }
}
.custom-select-cities__dropdown {
  z-index: 25;
  height: auto;
  //padding: 6px;
  max-height: 320px;
  background: white;
  position: absolute;
  box-sizing: border-box;
  //transform: translateY(5px);
  top: 100%; left: 0; right: 0;

  border-radius: 0 0 16px 16px;
  border: 1px solid #EBEBEB;
  border-top: none;

  .--search {
    width: 100%;
    height: 40px;
    padding: 0 16px;
    border-radius: 10px;
    border: 1px solid #EBEBEB;
  }
  .--search-content {
    padding: 6px;
    padding-bottom: 0;
  }

  .--section {
    flex: auto;
    display: flex;
    margin-top: 10px;
    flex-direction: column;
  }
  .--section .--title {
    color: #000000;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
    margin-left: 8px;
  }
  .--section .--items {
    display: flex;
    overflow: auto;
    flex-direction: column;
    li:not(:first-child) {
      border-top: 1px solid #EBEBEB;
    }
  }
}


.cscd-option-item {
  display: flex;
  align-items: center;
  padding: 12px 22px;
  cursor: pointer;
  .--value {
    color: #000;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
  }
  &:hover {
    background: #ebebeb59;

    .--image:after {
      border-color: rgb(248 248 248);
    }
  }
}
</style>
